import React , {useState, useEffect, useRef} from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { useTranslation } from "react-i18next";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Avatar from "@material-ui/core/Avatar";
import { deepOrange, deepPurple } from "@material-ui/core/colors";
import Divider from "@material-ui/core/Divider";
import { ListItemIcon } from "@material-ui/core";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";
import RichTooltip from "./RichTooltip";
import LoginMenu from "./LoginMenu";
import ElemDeleteControl from "../../BasicFormControls/ElemDeleteControlWrapper";
import {isColor,checkValid,getNumber} from "../../../Resources/globalFunctions";
import SvgDefaultImg from "../../../Icons/Image/defaultImg.svg";
import { useLayoutEffect } from "react";
import {disconnectUser} from '../../../components/IFormDesignerLayout/RequestLogic'
import { useDispatch, addContexts, useSelector } from "../../../Redux";
import axios from '../../../axios';
import { functions } from "../../../components/IFormDesignerLayout/ApplicationAPI/applicationApi";
import { GetState, GetStateFromData } from "../../../components/CustomHooks/CustomHooks";
import { executeRouteJourney1 } from "../../../ReusableComponents/Events/EventExecutionLogic";
import secureLocalStorage from "react-secure-storage";
import secureSessionStorage from "../../../utils/secureSessionStorage";

const useAvatarStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    marginRight: "9px",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
  },
  purple: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
  },
  small: {
    width: "30px" || theme.spacing(3),
    height: "30px" || theme.spacing(3),
  },
  text: {
    textAlign: "left",
    font: "normal normal 600 12px/17px Open Sans",
    letterSpacing: "0px",
    color: "#FFFFFF",
    opacity: 1,
  },
  background: {
    background:
      (theme?.primaryColor || "#FF6600") + " 0% 0% no-repeat padding-box",
    opacity: "1",
  },
}));

const useMenuStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    textAlign: theme?.imageAlignment || "center",
    font: "normal normal bold 16px/22px Open Sans",
    letterSpacing: "0.48px",
    color: "#222222",
    opacity: 1,
    padding: '0px 20px',
    marginBottom: "0 !important"
  },
  menuWrapper: {
    // background: '#FFFFFF 0% 0% no-repeat padding-box',
    boxShadow: "0px 0px 4px #BABABA80",
    border: "1px solid #F0F0F0",
    opacity: 1,
    // width: '254px',
    // height: '158px',
  },
  paper: {
    boxShadow: "0px 0px 4px #BABABA80",
    border: "1px solid #F0F0F0",
    opacity: 1,
  },
}));

const useAppBarStyles = makeStyles((style) => ({
  root: {
    borderBottom: "2px solid " + (style?.primaryColor || '#FF6600'),
    backgroundColor: style?.backgroundColor || "",
  },
  colorDefault: {},
  colorPrimary: {
    backgroundColor: "white",
  },
}));

const useToolBarStyles = makeStyles((theme) => ({
    regular:{
        minHeight: '48px',
    },
    gutters:{
        paddingLeft:'15px',
        paddingRight:'15px',
    },
}));

const useTypographyStyles = makeStyles((theme) => ({
    lastLogin:{
        textAlign: 'left',
        font: 'normal normal normal 12px/17px Open Sans',
        letterSpacing: '0px',
        color: '#000000',
    },
    lastLoginTime:{
        textAlign: 'left',
        font: 'normal normal normal 12px/17px Open Sans',
        letterSpacing: '0px',
        color: '#606060',
    },
    lastLoginWrapper:{
        marginTop:'9px',
        marginBottom:'12px',
    }
}));

const useDividerStyles = makeStyles((theme) => ({
  root: {
    // height: "28px !important",
    // height: (style) => style.dividerHeight+'px !important' || '28px !important',
    alignSelf: "stretch",
    // margin: "auto",
    border: "1px solid #767676",
    width: "0px",
    opacity:'0.5',
    margin: '10px 10px',
    minHeight: '100%',
  },
  dividerInset: {
    margin: `5px 0 0 ${theme.spacing(9)}px`,
  },
  dividerText:{
    // textAlign: 'left',
    textAlign: 'right',
    letterSpacing: '0px',
    color: '#606060',
    opacity: '1',
    lineHeight:'14px',
  },
  dividerTextDiv:{
    paddingRight: '20px',
  },
  dividerDiv:{
    padding:0,
  },
}));

const useImageStyles = makeStyles((theme) => ({
  image: {
    borderColor: (style) => style.BorderColor || "#d7d7d7",
    borderWidth: (style) => style.BorderWidth || "0px",
    borderRadius: (style) => style.BorderRadius || "0px",
    borderStyle: "solid",
    height: (style) => `${style.height || 34}px`,
    width: (style) => `${style.width || 170}px`,
    maxWidth: "250px",
    maxHeight: "100px",
    minWidth: "16px",
    minHeight: "16px",
    transform: (style) =>
      style.transform === "enlarge" ? `scale(${style.enlarge})` : null,
    // maxHeight:'49px',
    // maxWidth:'164px',
    // paddingRight: "10px",
    // paddingLeft: "10px",
    paddingTop: "4px",
    paddingBottom: "4px",
  },
  imageDummy: {
    maxHeight: "49px",
    maxWidth: "164px",
    paddingRight: "15px",
    paddingLeft: "15px",
    paddingTop: "8px",
    paddingBottom: "8px",
  },
  profile: {
    paddingRight: "10px",
    paddingLeft: "10px",
  },
  profileButton: {
    margin: "0 !important",

    "& .MuiIconButton-label": {
      padding: "0 !important"
    }
  },
  profileDummy: {
    // paddingRight: "15px",
    // paddingLeft: "15px",
  }
}));


const LoginHeader = (props) => {

  const contexts = GetStateFromData(props.containerId);

  const {controlSelected, templateLoaded} = GetState("controlSelected", "templateLoaded");

  const gdtoken=contexts.gdtoken;
  const launchpadKey=secureSessionStorage.getItem("Authorization") || JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token;
  var jwtToken = launchpadKey || undefined;
  const { t } = useTranslation(["styles", "translation"]);
  // const testClick=contexts.testClick;
  const {loggedInUserData, applicationNameObj, activePage, activeSubForm, formMataData,childComp, formState2, testClick, setLoginHeaderHeight, homePage }=contexts.contexts;
  // console.log("@loggedInUserData :: ", loggedInUserData,
  // " | @activePageFormId :: ",props.activePageFormId,
  // " | @defaultFormId :: ",props.defaultFormId,
  // " | @activePage :: ",props.activePage
  // );

    var style = props?.data?.style || {};
    const classes = useImageStyles(style);

    const primaryColor = props?.themeData?.BasicTheme?.PrimaryColor || '#FF6600';

    const avatarClasses =  useAvatarStyles();
    const menuClasses = useMenuStyles(style);
    const appBarClasses = useAppBarStyles({
      primaryColor: primaryColor,
      BackColor: style?.backgroundColor,
    });
    const toolBarClasses = useToolBarStyles();
    const typographyClasses = useTypographyStyles(style);
    
    const imageRef = React.createRef();
    const dividerRef = React.createRef(null);
    
    // const [imgheight, setImgheight] = useState(28);
    const [dividerHeight , setDividerHeight] = useState(28*0.8);
    useEffect(() => {
      // console.log(" | dividerHeight :: ", dividerHeight);
    }, [ dividerHeight]);
    
    // let imgheight;
    useLayoutEffect(() => {
      // console.log("dividerRef useLayoutEffect!");
      if (imageRef) {
        let imgHeightVar = imageRef?.current?.clientHeight;
        // console.log("imgHeightVar :: ", imgHeightVar);
          setDividerHeight((prevState) => {
            if (prevState !== imgHeightVar) {
              return imgHeightVar*0.8;
            } else {
              return prevState;
            }
          });
          if (dividerRef.current!==null){
            // console.log("dividerRef :: ", dividerRef, imgHeightVar, (imgHeightVar*0.8));
            dividerRef.current.style.height = (imgHeightVar*0.8) + "px !important";
            // console.log(
            //   "dividerRef.current.style :: ",
            //   dividerRef.current.style.height,
            //   "| ",
            //   (imgHeightVar * 0.8) + "px !important"
            // );
          }
        }
    },[imageRef, dividerRef]);
    const dividerClasses = useDividerStyles({ dividerHeight: dividerHeight });




    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, setOpen] = useState(false);
    
    // const open = Boolean(anchorEl);

    const [loggedIn, setLoggedIn] = useState(false);
    const [profileInfo, setProfileInfo] = useState({
      userName: "",
      profileImage: "",
      fullName: ""
    });
    const data = props.data;
    
    const routeonLogoClick = async () =>{
      if(props?.data?.style?.Route !=="Select"){
        await executeRouteJourney1(props?.data?.style?.Route,"",props?.data?.id,props?.data,contexts)
      }
    }

    const logoutFunc = () => {
      // setLoggedIn(false);
      // disconnectUser();

      const logout_payLoad={
        "gdtoken":gdtoken
      };

      axios.post("/viewform/disconnectUser",logout_payLoad,{withCredentials:true})
      .then(res=>{
        if(window.setCustomLogoutRedirection){
          functions.executeLogoutRedirection(window.setCustomLogoutRedirection)
        }else{
          window.location.reload(false);
        }
      })
      .catch(err=>{
        // alert("unable to logout: Logout API failed");
        console.log("unable to logout: Logout API failed");
      })
    }

    const getUserProfile = async () => {
      try {
        if(gdtoken && axios?.defaults?.headers?.common?.['Authorization']) {
          const response = await axios.post("/viewform/getUserInfo", { gdtoken });

          const userName = response?.data?.Name || "";
          const fullName = `${response?.data?.PersonalName || ""}${
            response?.data?.FamilyName ? ` ${response?.data?.FamilyName}` : ""
          }`;

          setProfileInfo((prev) => ({
            ...prev,
            profileImage: response?.data?.userImageData || "",
            userName,
            fullName: fullName || userName
          }));
        }
      } catch (error) {
        console.log("error", error);
      }
    };

    useEffect(() => {
      const isLoginHeader = (props.showLoginHeader && (formState2.formName !== homePage && props.activePageFormId != props.defaultFormId) && props.activePageFormId);

      if(!formMataData && (isLoginHeader || props?.isSSO)) {
        getUserProfile();
      }
    }, [gdtoken, activePage, axios?.defaults?.headers?.common?.['Authorization']]);

    useEffect(() => {
      // console.log("@ props loggedIn loggedIn props", props.loggedIn);
      setLoggedIn((prevState) => {
        if(prevState!==props.loggedIn){
          return props.loggedIn;
        } else {
          return prevState;
        }
      })
    }, [props.loggedIn]);

    let textAlign = "center";
    if(style?.imageAlignment) {
      if(window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA") {
        if(style?.imageAlignment === "left") textAlign = "right"
        if(style?.imageAlignment === "right") textAlign = "left"
      } else {
        if(style?.imageAlignment === "left") textAlign = "left"
        if(style?.imageAlignment === "right") textAlign = "right"
      }
    }


    const labelStyle = {
      color: style?.FontColor, // || "#000",
      fontFamily: style?.FontFamily, // || "Open Sans",
      fontSize: style?.FontSize, // || "12px",
      fontWeight: style?.FontWeight, // || "100",
      fontStyle: style?.FontStyle, // || "normal",
      textAlign: textAlign,
    };

    const paperProps = {
      elevation: 0,
      sx: {
        overflow: "visible",
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
        mt: 1.5,
        "& .MuiAvatar-root": {
          width: 32,
          height: 32,
          ml: -0.5,
          mr: 1,
        },
        "&:before": {
          content: '""',
          display: "block",
          position: "absolute",
          top: 0,
          right: 14,
          width: 10,
          height: 10,
          bgcolor: "background.paper",
          transform: "translateY(-50%) rotate(45deg)",
          zIndex: 0,
        },
      },
    };

    const headerStyleJson = {
      backgroundColor: style?.BackColor || "",
      borderBottom: "2px solid " + primaryColor,
    };

    const avatarStyleJson = {
      backgroundColor: primaryColor
    };

    const menuStyleJson = {
      backgroundColor: primaryColor+'15'
    };

    const handleChange = (event) => {
      setLoggedIn(event.target.checked);
    };

    const handleMenu = (event) => {
      setAnchorEl(event.currentTarget);
      setOpen(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
      setOpen(null);
    };

    useEffect(() => {
      if(formState2?.loginImageHeaderPage) {
        window.loginImageHeaderPage = formState2.loginImageHeaderPage;
      }
    }, [formState2?.loginImageHeaderPage])

  const imageBaseURL =
    childComp === "application" || activePage || activeSubForm || templateLoaded
      ? `${window.apb_backend_app_context}/idesign/getImage/${applicationNameObj.applicationName}/${templateLoaded ? "%20" : (formState2?.loginImageHeaderPage || window?.loginImageHeaderPage)}/${window?.activeCabinet_formbuilder}/`
      : "";

      const resizeObserverRef = useRef(null);
    // const [column_Height, setColumn_Height] = useState();
    // const colRef = useRef()

    useLayoutEffect(() => {
        // Initialize ResizeObserver and attach it to the div element
        // if(!props.previewmode){
            const targetElement = document.querySelector(`#loginHeader`) // Replace with your selector
    
            if (!targetElement) {
            console.error('Element not found');
            return;
            }
    
            resizeObserverRef.current = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { width, height, top, bottom } = entry.contentRect;
                console.log('Width6:', width);
                // canvas_Height.current = height + 'px';
                console.log('Height6:', height);
                if(!props?.previewmode)
                  setLoginHeaderHeight(height);
                // setColumn_Height(height)
                console.log('Top6:', top);
                console.log('Bottom6:', bottom);
            }
            });
    
            // Start observing the div element
            // if(!props?.previewmode){
                // if (colRef.current) {
                resizeObserverRef.current.observe(targetElement);
                // }
            // }
    
            // Cleanup function
            return () => {
            if (resizeObserverRef.current) {
                resizeObserverRef.current.unobserve(targetElement);
            }
            };
        // }
    }, [props?.data?.style?.iconFile, props?.data?.style?.size, props?.data?.style?.icon?.file,props?.activePageFormId,props?.activePage?.formId]);

  // console.log("loggedIn :: ", loggedIn);
  // if(loggedIn || props.previewmode && props.showLoginHeader){
  if ((props.showLoginHeader && (applicationNameObj?.formName !== homePage && props.activePageFormId != props.defaultFormId) && props.activePageFormId) || props?.isSSO) {
    return (
      <div onClick={(e) => testClick(e, props.data, "n")}  
        style={{ 
          position: "sticky",
          display: "block",
          marginTop: props?.previewmode ? "" : "16px",
          zIndex: "2",
          top: "0",
          width:"100%"
        }} tabIndex="1" id="loginHeader"
      >
        <AppBar
          position="static"
          color={appBarClasses.colorPrimary}
          elevation={0}
          control_id="LoginHeader"
          elem_type="LoginHeader"
          className={appBarClasses.root}
          style={headerStyleJson}
        >
          <Toolbar
            className={
              toolBarClasses.regular +
              " " +
              toolBarClasses.gutters +
              (props.previewmode !== true ? " noPointerEvent" : "")
            }
            control_id="LoginHeader"
            elem_type="LoginHeader"
          >
            {/* <IconButton
                edge="start"
                className={menuClasses.menuButton + " noPointerEvent"}
                color="inherit"
                aria-label="menu"
                control_id="LoginHeader"
                elem_type="LoginHeader"
              >
                NEWGEN
              </IconButton> */}
            {props.previewmode === true &&
            (props?.data?.style?.iconFile === undefined ||
              props?.data?.style?.iconFile === "") ? (
              <></>
            ) : (
              <>
                <img
                  // id={suggestedId}
                  ref={imageRef}
                  // onClick={(event) => handleImageClick(event)}
                  className={
                    // classes.image
                    props?.data?.style?.iconFile === undefined ||
                    props?.data?.style?.iconFile === ""
                      ? classes.imageDummy
                      : classes.image
                  }
                  alt="Login Header Icon"
                  src={
                    // style.uploadType === "file"
                    // ?
                    checkValid(props?.data?.style?.iconFile) || SvgDefaultImg
                    // (checkValid(props?.data?.style?.iconFile) &&`${imageBaseURL}${checkValid(props?.data?.style?.iconFile)}`) || SvgDefaultImg
                    // : checkValid(style.imageUrl) || SvgDefaultImg
                  }
                  style={props?.data?.style?.Route !=="Select" ?{cursor:"pointer"}:null}
                  onClick={()=>routeonLogoClick()}
                />
                {/* {console.log("dividerHeight return ", dividerHeight)} */}
                {/* {
                  // dividerHeight &&
                  <Divider
                    ref={dividerRef}
                    orientation="vertical"
                    flexItem
                    className={dividerClasses.root}
                    style={{ height: dividerHeight + "px !important" }}
                  />
                } */}
              </>
            )}
            <Typography
              variant="h6"
              className={
                menuClasses.title + " noPointerEvent"
              }
              control_id="LoginHeader"
              elem_type="LoginHeader"
              style={labelStyle}
            >
              {props.previewmode === true &&
              (props.data?.style?.PageTitle === undefined ||
                props.data?.style?.PageTitle === "")
                ? ""
                : props.data?.style?.PageTitle ? t(`translation:${props.data?.style?.PageTitle}`) : "Page Title Here"}
            </Typography>

            {loggedIn && (
              <div className={
                // classes.image
                props?.data?.style?.iconFile === undefined ||
                props?.data?.style?.iconFile === ""
                  ? classes.profileDummy
                  : classes.profile
              }>
                <RichTooltip
                  content={
                    <LoginMenu
                      showAvatar={true}
                      greeting={`${t("translation:Hi")}, ${
                        profileInfo.fullName || t("translation:New User")
                      }`}
                      showDate={true}
                      dateLabel={`${t("translation:Last login time")}:`}
                      dateValue={`${ loggedInUserData?.lastLoggedInTime || "17/11/2021 12:34:30"}`}
                      separatorText={`${t("translation:USER SETTINGS")}`}
                      logoutIcon={<ExitToAppOutlinedIcon fontSize="small" />}
                      logoutLabel={`${t("translation:Logout")}`}
                      logoutFunc={logoutFunc}
                      menuStyle={menuStyleJson}
                      avatar={
                        <Avatar
                          style={avatarStyleJson}
                          className={
                            //   avatarClasses.orange +
                            avatarClasses.root +
                            " " +
                            avatarClasses.background +
                            " " +
                            avatarClasses.small +
                            " " +
                            avatarClasses.text
                          }
                          src={profileInfo.profileImage}
                        >
                          {profileInfo.fullName ? profileInfo.fullName?.trim()[0] : 'N'}
                        </Avatar>
                      }
                    />
                  }
                  open={open}
                  placement="bottom-end"
                  onClose={() => setOpen(false)}
                  externalClassPaper={""}
                  externalClassArrow={""}
                >
                  <IconButton
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleMenu}
                    color="inherit"
                    className={classes.profileButton}
                  >
                    <Avatar
                      style={avatarStyleJson}
                      className={
                        //   avatarClasses.orange +
                        avatarClasses.background +
                        " " +
                        avatarClasses.small +
                        " " +
                        avatarClasses.text
                      }
                      src={profileInfo.profileImage}
                    >
                      {profileInfo.fullName ? profileInfo.fullName?.trim()[0] : 'N'}
                    </Avatar>
                  </IconButton>
                </RichTooltip>
                {/* <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem>
                  <Avatar /> Profile
                </MenuItem>
                <MenuItem>
                  <Avatar /> My account
                </MenuItem>
                <Divider />
                <MenuItem>
                  <ListItemIcon>
                    <AccountCircleOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  Add another account
                </MenuItem>
                <MenuItem>
                  <ListItemIcon>
                    <SettingsOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  Settings
                </MenuItem>
                <MenuItem>
                  <ListItemIcon>
                    <ExitToAppOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu> */}
                {/* <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={open}
                onClose={handleClose}
                elevation={0}
                className={menuClasses.menuWrapper + " " + menuClasses.paper}
                PaperProps={paperProps}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                //   onClick={handleClose}
                >
                  Profile
                </MenuItem>
                <MenuItem>
                  <Typography
                    // sx={{ mt: 0.5, ml: 9 }}
                    color="text.secondary"
                    display="block"
                    variant="caption"
                    className={typographyClasses.lastLogin}
                  >
                    Last login time:
                  </Typography>
                  <Typography
                    // sx={{ mt: 0.5, ml: 9 }}
                    color="text.secondary"
                    display="block"
                    variant="caption"
                    className={typographyClasses.lastLoginTime}
                  >
                    17/11/2021 12:34:30
                  </Typography>
                </MenuItem>
                <div className="row">
                  <div className={"col " + dividerClasses.dividerTextDiv}>
                    <Typography
                      // sx={{ mt: 0.5, ml: 9 }}
                      color="text.secondary"
                      display="block"
                      variant="caption"
                      className={dividerClasses.dividerText}
                    >
                      USER SETTINGS
                    </Typography>
                  </div>
                  <div className={"col " + dividerClasses.dividerDiv}>
                    <Divider component="li" />
                  </div>
                </div>
                <MenuItem>
                  <ListItemIcon>
                    <ExitToAppOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu> */}
              </div>
            )}
          </Toolbar>
        </AppBar>
        {props.previewmode !== true && controlSelected?.id === props?.data?.id ? (
          <ElemDeleteControl
          containerId={props.containerId}
            id={props?.data?.id}
            elemType={props?.data?.elem_type}
            data={data}
            top="0"
          />
        ) : (
          <></>
        )}
      </div>
    );
  } else {
    return <></>;
  }
};

export default LoginHeader;
